import { zipCodes } from './constants';
export const isComplexPassword = (password) => {
  const anUpperCase = /[A-Z]/;
  const aLowerCase = /[a-z]/;
  const aNumber = /[0-9]/;
  const minLong = 8;
  const obj = { result: true, error: [] };
  if (password.length < minLong) {
    obj.result = false;
    obj.error.push('Be at least 8 characters.');
  }
  let numUpper = 0,
    numLower = 0,
    numNums = 0;
  for (let i = 0; i < password.length; i++) {
    if (anUpperCase.test(password[i])) {
      numUpper++;
    } else if (aLowerCase.test(password[i])) {
      numLower++;
    } else if (aNumber.test(password[i])) {
      numNums++;
    }
  }
  if (numUpper < 1) {
    obj.result = false;
    obj.error.push('At least one capital letter');
  }
  if (numLower < 1) {
    obj.result = false;
    obj.error.push('At least one lowercase letter');
  }
  if (numNums < 1) {
    obj.result = false;
    obj.error.push('At least one number');
  }
  return obj;
};

export const phoneMask = (phone) => {
  let maskedPhone = phone.replace(/\D/g, '');
  const size = maskedPhone.length;
  if (size < 6) {
    maskedPhone = maskedPhone.replace(/^(\d{1,3})/, '($1)');
  } else {
    maskedPhone = maskedPhone.replace(/^(\d{1,3})(\d{1,3})(\d{1,5}).*/, '($1)$2-$3');
  }
  return maskedPhone;
};

export const removeAlfa = (val) => {
  const value = val.toString();
  if (!val) {
    return '';
  }

  return value.replace(/\D/g, '');
};

export const timeout = (milliseconds = 2000) => new Promise((resolve) => setTimeout(resolve, milliseconds));

export function handleInput(value, options = {}) {
  return {
    value,
    errors: false,
    displayErrors: false,
    errorMsg: '',
    setError: function (msg) {
      this.errors = true;
      this.errorMsg = msg;
      if (options.showErrors) {
        this.displayErrors = true;
      }
    },
    min: function (minLength = 0) {
      if (!this.value) {
        return this;
      }
      const length = this.value.toString().length;
      if (length < minLength) {
        this.setError(`Length should be greater than ${minLength}`);
      }
      return this;
    },
    max: function (maxLength = 999999) {
      if (!this.value) {
        return this;
      }
      const length = this.value.toString().length;
      if (length > maxLength) {
        this.setError(`Length should be lower than ${maxLength}`);
      }
      return this;
    },
    required: function () {
      if (!this.value) {
        this.setError('This field is required');
      }
      return this;
    },
    onlyNumbers: function () {
      if (!this.value) {
        return this;
      }
      const regex = /[0-9]/g;
      if (!regex.test(this.value)) {
        this.setError('Invalid number');
      }
      return this;
    },
    zip: function (country = 'US') {
      if (!this.value) {
        return this;
      }

      const defaultRegex = /(^[A-Za-z0-9]{5}$)|(^[A-Za-z0-9]{9}$)/;

      const foundRegex = zipCodes.find((regex) => regex.country === country);
      const regex = foundRegex ? foundRegex.regex : defaultRegex;

      if (!regex.test(this.value)) {
        this.setError('Invalid zip');
      }
      return this;
    },
    phoneMask: function () {
      this.value = phoneMask(this.value);
      return this;
    },
    complexPassword: function () {
      const validation = isComplexPassword(this.value);
      if (!validation.result) {
        this.setError(validation.error.join(', '));
      }
      return this;
    },
    sameValue: function (expected) {
      if (expected !== this.value) {
        this.setError("Passwords don't match");
      }
      return this;
    },
    website: function () {
      if (!this.value) {
        return this;
      }
      const regex =
        /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i;
      if (!regex.test(this.value)) {
        this.setError('Invalid website');
      }
      return this;
    },
    email: function () {
      if (!this.value) {
        return this;
      }
      const regex =
        /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
      if (!regex.test(this.value)) {
        this.setError('Invalid email address');
      }
      return this;
    },
  };
}



// WEBPACK FOOTER //
// ./src/utils.js